import React, { useEffect, useState } from "react";
import Navbar from "@/components/Navbar/Navbar";
import SideMenu from "@/components/MyAccount/SideMenu";
import "react-datepicker/dist/react-datepicker.css";
import ApiHttpClient from "@/HttpClient";
import { toast } from "@/components/ui/use-toast";
import { useParams } from "react-router-dom";
import { IoWarningOutline } from "react-icons/io5";
import {
    OrganizationManagementModel,
    WarehouseModel,
    WorkingPointManagementModel,
    WorkingPointModel
} from "@/api/Models";
import { getDecodedTokenDetails } from "@/components/Token/TokenService";
import { canAccessOrganizationManagmentButton, canAccessWorkingPointManagmentButton } from "@/components/Auth/AuthValidator";

function ClientManagementOrganization() {
    const queryParams = useParams();
    const clientId = queryParams.clientId;

    const [selectedOption, setSelectedOption] = useState<string | null>(null);
    const [creditLimit, setCreditLimit] = useState(1);
    const [showLimitCreditWarning, setShowLimitCreditWarning] = useState(false);
    const [showMaxLimitCreditWarning, setShowMaxLimitCreditWarning] = useState(false);
    const [clientSettingsOrganization, setClientSettingsOrganization] = useState(false);
    const [clientSettingsWorkingPoint, setClientSettingsWorkingPoint] = useState(false);
    const [selectedDatesNumbers, setSelectedDatesNumbers] = useState<any>([]);
    const [initialData, setInitialData] = useState<any>({}); // pentru comparare la salvare partiala
    const [organizationId, setOrganizationId] = useState("");
    const [organizationUC, setOrganizationUC] = useState(0);
    const [canHaveDiscounts, setCanHaveDiscounts] = useState(true);
    const [canHaveOverdraftAuto, setCanHaveOverdraftAuto] = useState(false);
    const [canHaveOverdraftManual, setCanHaveOverdraftManual] = useState(false);
    const [stockValidation, setStockValidation] = useState(false);
    const [showZeroStock, setShowZeroStock] = useState(false);
    const [isCreditLimitActive, setIsCreditLimitActive] = useState(false);
    const [overdraftValue, setOverdraftValue] = useState(1);
    const [secondOverdraftValue, setSecondOverdraftValue] = useState(1);
    const [availabilityBalance, setAvailabilityBalance] = useState<number>();
    const [invoiceDueDateType, setInvoiceDueDateType] = useState("date");
    const [invoiceDueDays, setInvoiceDueDays] = useState(21);
    const [invoiceDueDate, setInvoiceDueDate] = useState("");
    const [invoiceDuePeriod, setInvoiceDuePeriod] = useState(1);
    const [warehouses, setWarehouses] = useState<any>();
    const [warehousesAtacFlow, setWarehousesAtacFlow] = useState<any>();
    const [organizationLocations, setOrganizationLocations] = useState<[WorkingPointModel]>();
    const [workingPointLocationWP, setWorkingPointLocationWP] = useState<any>("");
    const [canChooseDeliveryPoint, setCanChooseDeliveryPoint] = useState(false);
    const [pairWorkingPointStore, setPairWorkingPointStore] = useState<any>();
    const [pairWorkingPointWarehousePlatform, setPairWorkingPointWarehousePlatform] = useState<any>();
    const [canEditWorkingPointButton, setEditWorkingPointnButton] = useState<any>();
    const [workingPointOrganization, setWorkingPointOrganization] = useState<any>();
    const [canEditOrganizationButton, setEditOrganizationButton] = useState<any>();
    const [fidelity, setFidelity] = useState<string | null>();
    const [useAtacFlow, setUseAtacFlow] = useState<any>();
    const [transportFeeId, setTransportFeeId] = useState<number | null>();
    const [minimumValueTransportFee, setMinimumValueTransportFee] = useState<number | null>();
    const [pairAtacWarehouseId, setPairAtacWarehouseId] = useState<number | null>();
    const isValidFidelity = fidelity?.length === 13;
    
    const handleChangeFidelity = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        if (/^\d{0,13}$/.test(value)) {
            setFidelity(value);
        }
    };
    
    const [deliveryCalendarsWP, setDeliveryCalendarsWP] = useState([
        { logisticActivity: 0, logisticActivityName: "", days: [false, false, false, false, false, false, false] },
    ]);

    const handleClientSettingsOrganization = () => {
        setClientSettingsOrganization(!clientSettingsOrganization);
        setClientSettingsWorkingPoint(false);
    }

    const handleClientSettingsWorkingPoint = () => {
        setClientSettingsWorkingPoint(!clientSettingsWorkingPoint);
        setClientSettingsOrganization(false);
    }

    const handleCheckboxChange = (option: string) => {
        setSelectedOption(option === selectedOption ? null : option);

        if (option === "billing-date") {
            setInvoiceDueDateType("date");
            setInvoiceDuePeriod(1);
        } else if (option === "after-delivery") {
            setInvoiceDueDateType("period");
            setInvoiceDueDate("");
        }
    };

    const handleCreditLimitChange = (e: any) => {
        const value = e.target.value;
        setCreditLimit(value);

        if (value >= secondOverdraftValue) {
            setSecondOverdraftValue(value);
            setShowMaxLimitCreditWarning(true);
        } else if (value < secondOverdraftValue) {
            setShowMaxLimitCreditWarning(false);
        }
        setOverdraftValue(Number(value));

        if (Number(value) === 0) {
            setShowLimitCreditWarning(true);
        } else setShowLimitCreditWarning(false);
    };

    const handleMaxCreditLimitChange = (e: any) => {
        const value = e.target.value;

        setSecondOverdraftValue(Number(value));

        if (Number(value) < overdraftValue) {
            setShowMaxLimitCreditWarning(true);
        } else {
            setShowMaxLimitCreditWarning(false);
        }
    };

    const handleNumberDatesToggle = (number: any) => {
        setSelectedDatesNumbers((prevSelected: any) =>
            prevSelected.includes(number)
                ? prevSelected.filter((n: any) => n !== number)
                : [...prevSelected, number]
        );
    };
    
    useEffect(() => {
        (async () => {
            const tokenDetails = await getDecodedTokenDetails();

            if (tokenDetails?.token) {
                try {
                    await canAccessOrganizationManagmentButton() ? setEditOrganizationButton(true) : setEditOrganizationButton(false);
                    await canAccessWorkingPointManagmentButton() ? setEditWorkingPointnButton(true) : setEditWorkingPointnButton(false);

                } catch (error) {
                    console.error('Failed to decode token', error);
                }
            } else {
                console.error('No token found');
            }
        })();
    }, []);

    useEffect(() => {
        const fetchOrganizationData = async () => {
            if (!clientId) return;

            try {
                const response = await ApiHttpClient().get<OrganizationManagementModel>(
                    `/organization/management/${clientId}`
                );
                if (response.status === 200) {
                    setInitialData(response.data);
                    setOrganizationId(clientId);
                    setOrganizationUC(response.data.organizationUC || 0);
                    setCanHaveDiscounts(response.data.canHaveDiscounts || false);
                    setCanHaveOverdraftAuto(response.data.canHaveOverdraftAuto || false);
                    setCanHaveOverdraftManual(response.data.canHaveOverdraftManual || false);
                    setStockValidation(response.data.stockValidation || false);
                    setShowZeroStock(response.data.showZeroStock || false);
                    setIsCreditLimitActive(response.data.isCreditLimitActive || false);
                    setOverdraftValue(response.data.overdraftValue || 1);
                    setSecondOverdraftValue(response.data.secondOverdraftValue || 1);
                    setAvailabilityBalance(response.data.availabilityBalance || 0);
                    setInvoiceDueDateType(response.data.invoiceDueDateType || "date");
                    setInvoiceDueDays(response.data.invoiceDueDays || 21);
                    setInvoiceDueDate(response.data.invoiceDueDate || "");
                    setInvoiceDuePeriod(response.data.invoiceDuePeriod || 1);
                    setOrganizationLocations(response.data.workingPoints);

                    if (response.data.invoiceDueDate) {
                        const datesArray = response.data.invoiceDueDate
                            .split(";")
                            .map((date: string) => parseInt(date.trim()));
                        setSelectedDatesNumbers(datesArray);
                    }
                } else {
                    toast({ description: "Eroare la obținerea datelor organizației." });
                }
            } catch (error) {
                toast({ description: "Nu s-au putut încărca datele organizației." });
                console.error("Error fetching organization data:", error);
            }
        };

        fetchOrganizationData();
    }, [clientId]);

    useEffect(() => {
        if (organizationLocations?.length && !workingPointLocationWP) {
            setWorkingPointLocationWP(organizationLocations[0].id);
        }
    }, [organizationLocations, workingPointLocationWP]);

    useEffect(() => {
        if (workingPointLocationWP && workingPointOrganization?.items?.length) {
            fetchWorkingPointData(workingPointLocationWP);
        }
    }, [workingPointLocationWP, workingPointOrganization]);

    useEffect(() => {
        const fetchWarehouses = async () => {
            let response = await ApiHttpClient().post<WarehouseModel>(`/warehouse/search`, {
                "advancedSearch": {
                    "fields": [
                        "warehousePlatform"
                    ],
                    "keyword": "MAGAZIN",
                },
            });

            setWarehouses(response.data);
        };

        fetchWarehouses();
    }, []);

    useEffect(() => {
        const fetchWarehousesAtacFlow = async () => {
            let response = await ApiHttpClient().post<WarehouseModel>(`/warehouse/search`, {
                "advancedFilter": {
                    "field": "isAtac",
                    "operator": "eq",
                    "value": true
                },
            });

            setWarehousesAtacFlow(response.data);
        };

        fetchWarehousesAtacFlow();
    }, []);

    useEffect(() => {
        const fetchWPOrganization = async () => {
            try {
                const response = await ApiHttpClient().post<any>(`/workingPoint/search`, {
                    "advancedSearch": {
                        "fields": ["organizationId"],
                        "keyword": clientId,
                    },
                });

                if (response.status === 200) {
                    setWorkingPointOrganization(response.data);
                } else {
                    toast({ description: "Eroare la obținerea organizației depozitului." });
                }
            } catch (error) {
                console.error("Error fetching working point organization:", error);
                toast({ description: "Nu s-au putut încărca datele despre organizație." });
            }
        };

        if (clientId) {
            fetchWPOrganization();
        }
    }, [clientId]);

    // const fetchWorkingPointData = async () => {
    //
    //     if (!workingPointOrganization || !workingPointOrganization.items?.length) return;
    //
    //     try {
    //         let id;
    //
    //         if(workingPointLocationWP) id = workingPointLocationWP;
    //         else {
    //             id = workingPointOrganization?.items?.[0]?.id;
    //         }
    //
    //         const response = await ApiHttpClient().get<WorkingPointManagementModel>(
    //             `/workingPoint/management/${id}`
    //         );
    //
    //         if (response.status === 200) {
    //             setCanChooseDeliveryPoint(response.data.canChooseDeliveryPoint || false);
    //             setWorkingPointLocationWP(response.data.id || id);
    //             setPairWorkingPointStore(response.data.pairWorkingPointStore || null);
    //             setPairWorkingPointWarehousePlatform(response.data.pairWorkingPointWarehousePlatform || null);
    //
    //             setDeliveryCalendarsWP((prev) =>
    //                 response.data.deliveryCalendars.map((calendar: any) => {
    //                     prev.find(
    //                         (prevCalendar) => prevCalendar.logisticActivity === calendar.logisticActivity
    //                     );
    //
    //                     return {
    //                         logisticActivity: calendar.logisticActivity,
    //                         deliveryCalendarId: calendar.deliveryCalendarId,
    //                         logisticActivityName:  "", // Preserve old label if it exists
    //                         days: [
    //                             calendar.day1 || false,
    //                             calendar.day2 || false,
    //                             calendar.day3 || false,
    //                             calendar.day4 || false,
    //                             calendar.day5 || false,
    //                             calendar.day6 || false,
    //                             calendar.day7 || false,
    //                         ],
    //                     };
    //                 })
    //             );
    //            
    //         } else {
    //             toast({description: "Eroare la obținerea datelor despre depozit."});
    //         }
    //     } catch (error) {
    //         console.error("Error fetching working point data:", error);
    //         toast({description: "Nu s-au putut încărca datele despre depozit."});
    //     }
    // }


    const fetchWorkingPointData = async (idParam: string) => {
        if (!workingPointOrganization?.items?.length) return;

        try {
            const wpId = idParam ?? workingPointLocationWP ?? workingPointOrganization.items[0].id;

            const response = await ApiHttpClient().get<WorkingPointManagementModel>(
                `/workingPoint/management/${wpId}`
            );

            if (response.status === 200) {
                const data = response.data;
                setCanChooseDeliveryPoint(data.canChooseDeliveryPoint || false);
                setPairWorkingPointStore(data.pairWorkingPointStore || null);
                setPairWorkingPointWarehousePlatform(data.pairWorkingPointWarehousePlatform || null);
                setUseAtacFlow(data.useAtacFlow || false);
                setFidelity(data.fidelityId || null);
                setTransportFeeId(data.transportFeeId || null);
                setMinimumValueTransportFee(data.minimumValueTransportFee || null);
                setPairAtacWarehouseId(data.pairAtacWarehouseId || null);

                setDeliveryCalendarsWP(
                    data.deliveryCalendars.map((calendar: any) => ({
                        logisticActivity: calendar.logisticActivity,
                        deliveryCalendarId: calendar.deliveryCalendarId,
                        logisticActivityName: "",
                        days: [
                            calendar.day1 || false,
                            calendar.day2 || false,
                            calendar.day3 || false,
                            calendar.day4 || false,
                            calendar.day5 || false,
                            calendar.day6 || false,
                            calendar.day7 || false,
                        ],
                    }))
                );
                
                setInitialData({
                    id: data.id,
                    canChooseDeliveryPoint: data.canChooseDeliveryPoint,
                    pairWorkingPointStore: data.pairWorkingPointStore,
                    pairWorkingPointWarehousePlatform: data.pairWorkingPointWarehousePlatform,
                    deliveryCalendars: data.deliveryCalendars,
                    useAtacFlow: data.useAtacFlow,
                    fidelityId: data.fidelityId,
                    transportFeeId: data.transportFeeId,
                    minimumValueTransportFee: data.minimumValueTransportFee,
                    pairAtacWarehouseId: data.pairAtacWarehouseId
                });
            }
        } catch (error) {
            console.error("Error fetching working point data:", error);
            toast({ description: "Nu s-au putut încărca datele despre depozit." });
        }
    };


    // const handleWorkingPointChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    //     const id = e.target.value;
    //     setWorkingPointLocationWP(id); 
    //     fetchWorkingPointData(id);
    // };
    //
    // const handlePairWorkingPointWarehousePlatform = (e: any) => {
    //     const selectedId = e.target.value;
    //     setPairWorkingPointWarehousePlatform(selectedId);
    //     fetchWorkingPointData(workingPointLocationWP);
    // };
    //

    // useEffect(() => {
    //     if (workingPointOrganization?.items?.length) {
    //         const id = workingPointLocationWP || workingPointOrganization.items[0].id;
    //         fetchWorkingPointData(id);
    //         // eslint-disable-next-line react-hooks/exhaustive-deps
    //     }
    // }, [workingPointOrganization]);


    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        const currentData: any = {
            organizationId,
            organizationUC,
            canHaveDiscounts,
            canHaveOverdraftAuto,
            canHaveOverdraftManual,
            stockValidation,
            showZeroStock,
            isCreditLimitActive,
            overdraftValue,
            secondOverdraftValue,
            availabilityBalance,
            invoiceDueDateType,
            invoiceDueDays,
            invoiceDueDate,
            invoiceDuePeriod,
        };

        const hasChanges = Object.keys(currentData).some(
            (key) => currentData[key] !== initialData[key]
        );

        if (!hasChanges) {
            toast({ description: "Nu există modificări de salvat." });
            return;
        }

        if (!showLimitCreditWarning && !showMaxLimitCreditWarning && secondOverdraftValue > overdraftValue) {
            try {
                const response = await ApiHttpClient().post("/organization/management", currentData);
                if (response.status === 200) {
                    toast({ description: "Modificările au fost salvate cu succes!" });
                } else {
                    toast({description: "A apărut o eroare. Încercați din nou."});
                }
            } catch (error) {
                toast({ description: "Eroare la salvarea datelor." });
                console.error("Error:", error);
            }
        } else {
            setShowMaxLimitCreditWarning(true);
            toast({ description: "Verifica mesajele de eroare" });
        }
    };
    
    const handleSubmitWP = async (e: React.FormEvent) => {
        e.preventDefault();
        let id;

        if (workingPointLocationWP) id = workingPointLocationWP;
        else {
            id = workingPointOrganization?.items?.[0]?.id;
        }

        const deliveryCalendars = deliveryCalendarsWP.map((item: any) => ({
            deliveryCalendarId: item.deliveryCalendarId,
            logisticActivity: item.logisticActivity,
            day1: item.days[0],
            day2: item.days[1],
            day3: item.days[2],
            day4: item.days[3],
            day5: item.days[4],
            day6: item.days[5],
            day7: item.days[6],
        }));

        const currentData: any = {
            id,
            canChooseDeliveryPoint,
            pairWorkingPointStore,
            pairWorkingPointWarehousePlatform,
            deliveryCalendars,
            useAtacFlow,
            fidelityId: fidelity === "" ? null : fidelity,
            transportFeeId,
            minimumValueTransportFee,
            pairAtacWarehouseId
        };

        const hasChanges = Object.keys(currentData).some(
            (key) => currentData[key] !== initialData[key]
        );

        if (!hasChanges) {
            toast({ description: "Nu există modificări de salvat." });
            return;
        }

        if (!canChooseDeliveryPoint) {
            setPairWorkingPointWarehousePlatform(null);
            setPairWorkingPointStore(null);
        }

        if (useAtacFlow && (!pairAtacWarehouseId || pairAtacWarehouseId === 0)) {
            toast({ description: "Daca Atac Flow este true, selectarea unui magazin este obligatorie!" });
            return;
        }

        if (useAtacFlow && minimumValueTransportFee === 0) {
            toast({ description: "Daca Atac Flow este true, valoarea minima de transport trebuie sa fie mai mare decat 0!" });
            return;
        }

        if (useAtacFlow && (!transportFeeId || transportFeeId === 0)) {
            toast({ description: "Daca Atac Flow este true, selectarea unei taxe de transport este obligatorie!" });
            return;
        }

        if (useAtacFlow && !fidelity) {
            toast({ description: "Daca Atac Flow este true, completarea cardului de fidalitate este obligatorie!" });
            return;
        }

        try {
            const response = await ApiHttpClient().post("/workingPoint/management", currentData);

            if (response.status === 200) {
                toast({ description: "Modificările au fost salvate cu succes!" });

                if (workingPointLocationWP) {
                    await fetchWorkingPointData(workingPointLocationWP);
                }
            } else {
                toast({ description: "A apărut o eroare. Încercați din nou." });
            }
        } catch (error) {
            toast({ description: "Eroare la salvarea datelor." });
            console.error("Error:", error);
        }

    };

    useEffect(() => {
        setInvoiceDueDate(selectedDatesNumbers.join(";"));
    }, [selectedDatesNumbers]);

    useEffect(() => {
        const fetchLogisticActivities = async () => {

            if (pairWorkingPointWarehousePlatform === undefined) {
                return;
            }

            const requestPayload = {
                "advancedSearch": {
                    "fields": [
                        "warehousePlatform"
                    ],
                    "keyword": pairWorkingPointWarehousePlatform || "CALAN",
                },
            };

            try {
                const response = await ApiHttpClient().post(`/warehouse/search`, requestPayload);

                if (Array.isArray(response.data.items)) {

                    const newCalendars = response.data.items.map((item: any) => ({
                        logisticActivity: item.logisticActivity,
                        logisticActivityName: item.logisticActivityName,
                        days: [false, false, false, false, false, false, false],
                    }));
                    setDeliveryCalendarsWP((prev) => {

                        return newCalendars.map((newCalendar: any) => {
                            const existingCalendar = prev.find(
                                (prevCalendar) => prevCalendar.logisticActivity === newCalendar.logisticActivity
                            );
                            const newDays = existingCalendar?.days || newCalendar?.days;
                            let currentCalendar = existingCalendar || newCalendar;
                            currentCalendar.logisticActivityName = newCalendar.logisticActivityName;
                            currentCalendar.days = newDays;
                            return currentCalendar;
                        });
                    });
                }
            } catch (error) {
                console.error("Eroare la fetchLogisticActivities:", error);
            }
        };

        fetchLogisticActivities();
    }, [pairWorkingPointWarehousePlatform, workingPointLocationWP]);

    const handleCheckboxChangeDelivery = (rowIndex: any, dayIndex: any) => {
        setDeliveryCalendarsWP((prev) =>
            prev.map((row, i) =>
                i === rowIndex
                    ? {
                        ...row,
                        days: row.days.map((day, j) => (j === dayIndex ? !day : day)),
                    }
                    : row
            )
        );
    };

    const handlePairWorkingPointWarehousePlatform = async (e: any) => {
        let id;

        if (workingPointLocationWP) id = workingPointLocationWP;
        else {
            id = workingPointOrganization?.items?.[0]?.id;
        }
        const response = await ApiHttpClient().get<WorkingPointManagementModel>(
            `/workingPoint/management/${id}`
        );

        if (response.status === 200) {
            setDeliveryCalendarsWP(() =>
                response.data.deliveryCalendars.map((calendar: any) => {

                    return {
                        logisticActivity: calendar.logisticActivity,
                        deliveryCalendarId: calendar.deliveryCalendarId,
                        logisticActivityName: "", // Preserve old label if it exists
                        days: [
                            calendar.day1 || false,
                            calendar.day2 || false,
                            calendar.day3 || false,
                            calendar.day4 || false,
                            calendar.day5 || false,
                            calendar.day6 || false,
                            calendar.day7 || false,
                        ],
                    };
                })
            );
           setPairWorkingPointWarehousePlatform(e);
        }
    }

    const deliveryZones = [
        { id: 225214, label: "TAXA LIVRARE FRANCIZA 1" },
        { id: 225215, label: "TAXA LIVRARE FRANCIZA 2" },
        { id: 225216, label: "TAXA LIVRARE FRANCIZA 3" },
        { id: 225217, label: "TAXA LIVRARE FRANCIZA 4" },
        { id: 225218, label: "TAXA LIVRARE FRANCIZA 5" },
        { id: 225219, label: "TAXA LIVRARE FRANCIZA 6" },
        { id: 225220, label: "TAXA LIVRARE FRANCIZA 7" },
    ];


    return (
        <>
            <Navbar />
            <div className="flex flex-row items-start">
                <SideMenu />
                <div className="flex flex-col overflow-auto w-full">
                    <div className="text-4xl px-8 py-3 mt-5">Administrare Conditii Contractuale</div>
                    <p className="px-8"> Datele clientului: {clientId}</p>

                    <div className="grid grid-cols-1 gap-4 px-8 mt-6 text-center sm:grid-cols-3">
                        <button onChange={handleClientSettingsOrganization}>
                            <div>
                                <label
                                    htmlFor="ConfigurareClientOrganizatie"
                                    className="block w-full cursor-pointer rounded-lg border border-gray-200 p-3 text-gray-600 hover:border-black has-[:checked]:border-black has-[:checked]:bg-blue-400 has-[:checked]:text-white"
                                // tabIndex="0"
                                >
                                    <input className="sr-only" id="ConfigurareClientOrganizatie"
                                        type="radio"// tabIndex="-1"
                                        name="option" />

                                    <span className="text-sm"> Parametrii Organizatie </span>
                                </label>
                            </div>
                        </button>

                        <button onChange={handleClientSettingsWorkingPoint}>
                            <div>
                                <label
                                    htmlFor="ConfigurareClientPunctDeLucru"
                                    className="block w-full cursor-pointer rounded-lg border border-gray-200 p-3 text-gray-600 hover:border-black has-[:checked]:border-black has-[:checked]:bg-blue-400 has-[:checked]:text-white"
                                // tabIndex="0"
                                >
                                    <input className="sr-only" id="ConfigurareClientPunctDeLucru"
                                        type="radio"// tabIndex="-1"
                                        name="option" />

                                    <span className="text-sm"> Parametrii Punct de Lucru </span>
                                </label>
                            </div>
                        </button>
                    </div>

                    {clientSettingsOrganization && <div className="rounded-lg bg-white w-1/2 px-8 mt-6 lg:col-span-3">
                        <form onSubmit={handleSubmit} className="space-y-4">

                            <p className="text-gray-700 text-2xl">Tip client
                                - {workingPointOrganization.items[0].workingPointName}</p>
                            <div className="grid grid-cols-1 gap-4 text-center sm:grid-cols-2">
                                <div>
                                    <label
                                        htmlFor="Franciza"
                                        className="block w-full cursor-pointer rounded-lg border border-gray-200 p-3 text-gray-600 hover:border-black has-[:checked]:border-black has-[:checked]:bg-gray-300 has-[:checked]:text-white"
                                        // tabIndex="0"
                                    >
                                        <input className="sr-only" id="Franciza" type="radio"
                                               disabled={!canEditOrganizationButton}
                                               checked={organizationUC === 816}
                                               name="clientType" onChange={() => setOrganizationUC(816)}/>

                                        <span className="text-sm"> Franciza Soft (UC 816) </span>
                                    </label>
                                </div>

                                <div>
                                    <label
                                        htmlFor="B2B"
                                        className="block w-full cursor-pointer rounded-lg border border-gray-200 p-3 text-gray-600 hover:border-black has-[:checked]:border-black has-[:checked]:bg-gray-300 has-[:checked]:text-white"
                                        //tabIndex="0"
                                    >
                                        <input className="sr-only" id="B2B" type="radio"
                                               disabled={!canEditOrganizationButton} //tabIndex="-1"
                                               name="clientType" checked={organizationUC === 817}
                                               onChange={() => setOrganizationUC(817)}/>

                                        <span className="text-sm"> B2B (UC 817) </span>
                                    </label>
                                </div>
                            </div>

                            <p className="text-gray-700 text-2xl mt-8">Depasire limita de credit</p>
                            <div className="flex flex-row">
                                <div className="flex flex-col">
                                    <label className="inline-flex items-center cursor-pointer">
                                        <input type="checkbox" checked={canHaveOverdraftAuto}
                                               disabled={!canEditOrganizationButton}
                                               onChange={() => {
                                                   setCanHaveOverdraftAuto(!canHaveOverdraftAuto);
                                                   setCanHaveOverdraftManual(false);
                                               }}
                                               className="sr-only peer"/>
                                        <div
                                            className="relative my-8 w-11 h-6 bg-gray-200 rounded-full peer peer-focus:ring-4 peer-focus:ring-green-300 peer-checked:after:translate-x-4 rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-green-600"></div>
                                        <span
                                            className="ms-3 text-sm font-medium text-gray-900 dark:text-gray-300">Suporta depasire limita de credit in mod automat</span>
                                    </label>

                                    <label className="inline-flex items-center cursor-pointer">
                                        <input type="checkbox" checked={canHaveOverdraftManual}
                                               disabled={!canEditOrganizationButton}
                                               onChange={() => {
                                                   setCanHaveOverdraftManual(!canHaveOverdraftManual);
                                                   setCanHaveOverdraftAuto(false);
                                               }}
                                               className="sr-only peer"/>
                                        <div
                                            className="relative my-8 w-11 h-6 bg-gray-200 rounded-full peer peer-focus:ring-4 peer-focus:ring-green-300 peer-checked:after:translate-x-4 rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-green-600"></div>
                                        <span
                                            className="ms-3 ml-8 text-sm font-medium text-gray-900 dark:text-gray-300">Suporta depasire limita de credit in mod manual</span>
                                    </label>
                                </div>
                                <div>
                                    <form className="max-w-sm mx-auto mt-2">
                                        <label
                                            htmlFor="credit-limit"
                                            className="block mb-2 ml-8 text-sm font-medium text-gray-900"
                                        >
                                            Limita de credit:
                                        </label>
                                        <input
                                            type="number"
                                            id="credit-limit"
                                            className="bg-gray-50 border border-gray-300 ml-8 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                                            placeholder="0"
                                            required
                                            min="0"
                                            disabled={!canEditOrganizationButton}
                                            value={overdraftValue}
                                            onChange={handleCreditLimitChange}
                                        />
                                        {showLimitCreditWarning && <div className="flex flex-row mt-2">
                                            <IoWarningOutline className="text-orange-500 ml-8 text-xl"/>
                                            <p className="text-red-600/100 ml-2">Limita de credit trebuie sa fie mai
                                                mare ca 0</p>
                                        </div>}
                                    </form>

                                    <form className="max-w-sm mx-auto mt-2">
                                        <label
                                            htmlFor="max-credit-limit"
                                            className="block mb-2 ml-8 text-sm font-medium text-gray-900"
                                        >
                                            Limita maxima de credit:
                                        </label>
                                        <input
                                            type="number"
                                            id="max-credit-limit"
                                            className="bg-gray-50 border border-gray-300 ml-8 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                                            placeholder="1"
                                            required
                                            min={creditLimit}
                                            value={secondOverdraftValue}
                                            disabled={!canEditOrganizationButton}
                                            onChange={handleMaxCreditLimitChange}
                                        />
                                        {showMaxLimitCreditWarning && <div className="flex flex-row mt-2">
                                            <IoWarningOutline className="text-orange-500 ml-8 text-xl"/>
                                            <p className="text-red-600/100 ml-2">Limita maxima de credit trebuie sa fie
                                                mai mare decat limita de credit</p>
                                        </div>}
                                    </form>
                                </div>
                            </div>

                            <label className="inline-flex items-center cursor-pointer mr-12">
                                <input type="checkbox" checked={isCreditLimitActive}
                                       disabled={!canEditOrganizationButton}
                                       onChange={() => setIsCreditLimitActive(!isCreditLimitActive)}
                                       className="sr-only peer"/>
                                <div
                                    className="relative my-4 w-11 h-6 bg-gray-200 rounded-full peer peer-focus:ring-4 peer-focus:ring-green-300 dark:peer-focus:ring-green-800 dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-green-600"></div>
                                <span
                                    className="ms-3 ml-8 text-sm font-medium text-gray-900 dark:text-gray-300">Limita de credit activa</span>
                            </label>

                            <label className="inline-flex items-center cursor-pointer mr-12">
                                <input type="checkbox" checked={stockValidation} disabled={!canEditOrganizationButton}
                                       onChange={() => setStockValidation(!stockValidation)}
                                       className="sr-only peer"/>
                                <div
                                    className="relative my-4 w-11 h-6 bg-gray-200 rounded-full peer peer-focus:ring-4 peer-focus:ring-green-300 dark:peer-focus:ring-green-800 dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-green-600"></div>
                                <span
                                    className="ms-3 ml-8 text-sm font-medium text-gray-900 dark:text-gray-300">Suporta validarea stocului la plasarea precomenzii</span>
                            </label>

                            <label className="inline-flex items-center cursor-pointer mr-12">
                                <input type="checkbox" checked={showZeroStock} disabled={!canEditOrganizationButton}
                                       onChange={() => setShowZeroStock(!showZeroStock)}
                                       className="sr-only peer"/>
                                <div
                                    className="relative my-4 w-11 h-6 bg-gray-200 rounded-full peer peer-focus:ring-4 peer-focus:ring-green-300 dark:peer-focus:ring-green-800 dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-green-600"></div>
                                <span
                                    className="ms-3 ml-8 text-sm font-medium text-gray-900 dark:text-gray-300">Suporta afisarea produselor cu stoc zero</span>
                            </label>

                            <p className="text-gray-700 text-2xl mt-4">Termen de facturare</p>
                            <ul className="ml-4">
                                <li>
                                    <div className="flex flex-row mb-4">
                                        <label htmlFor="number-input-due-days"
                                               className="block mb-2 text-sm font-medium text-gray-900 dark:text-white mr-6 mt-2">Numar
                                            zile scadenta factura:</label>
                                        <input type="number" id="due-period-days"
                                               disabled={!canEditOrganizationButton}
                                               aria-describedby="helper-text-explanation"
                                               className="bg-gray-50 border border-gray-300 w-1/6 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block  p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                               placeholder="21" required value={invoiceDueDays}
                                               onChange={(e) => setInvoiceDueDays(Number(e.target.value))}/>
                                    </div>
                                </li>
                                <li>
                                    <div className="flex items-center mb-4">
                                        <input id="after-delivery" type="checkbox"
                                               disabled={!canEditOrganizationButton}
                                               checked={invoiceDueDateType === 'period'}
                                               onChange={() => handleCheckboxChange('after-delivery')}
                                               className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"/>
                                        <label htmlFor="after-delivery"
                                               className="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">Perioada
                                            dupa livrare</label>
                                    </div>
                                    <div className="flex flex-col mb-4">
                                        <div>
                                            <input id="billing-date" type="checkbox"
                                                   disabled={!canEditOrganizationButton}
                                                   checked={invoiceDueDateType === 'date'}
                                                   onChange={() => handleCheckboxChange('billing-date')}
                                                   className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"/>
                                            <label htmlFor="billing-date"
                                                   className="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">Facturare
                                                la data
                                            </label>
                                        </div>
                                        {selectedOption === 'billing-date' && <div>
                                            {selectedDatesNumbers.length > 0 && (
                                                <div className="mt-2 font-medium text-sm text-gray-600">
                                                    Datele selectate: {selectedDatesNumbers.join('; ')}
                                                </div>
                                            )}
                                        </div>}
                                    </div>
                                    {selectedOption === 'after-delivery' && (
                                        <div>
                                            <form className="mt-4">
                                                <div className="flex flex-row">
                                                    <label htmlFor="number-input"
                                                           className="block mb-2 text-sm font-medium text-gray-900 dark:text-white mr-6 mt-2">Selecteaza
                                                        numarul de zile dupa livrare:</label>
                                                    <input type="number" id="due-period"
                                                           disabled={!canEditOrganizationButton}
                                                           aria-describedby="helper-text-explanation"
                                                           className="bg-gray-50 border border-gray-300 w-1/6 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block  p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                                           placeholder="1" required min="1" value={invoiceDuePeriod}
                                                           onChange={(e) => setInvoiceDuePeriod(Number(e.target.value))}/>
                                                </div>
                                            </form>
                                            <div className="flex flex-row">
                                                <label htmlFor="number-input"
                                                       className="block mb-2 text-sm font-medium text-gray-900 dark:text-white mr-6 mt-7">Alege
                                                    o optiune:</label>
                                                <select id="underline_select"
                                                        className="block mt-4 py-2.5 px-0 w-1/4 text-sm text-gray-500 bg-transparent border-0 border-b-2 border-gray-200 appearance-none dark:text-gray-400 dark:border-gray-700 focus:outline-none focus:ring-0 focus:border-gray-200 peer">
                                                    <option value="US">Cumulat</option>
                                                    <option value="CA" selected>Zilnic</option>
                                                </select>
                                            </div>
                                        </div>
                                    )}
                                </li>
                            </ul>
                            <ul className="ml-4">
                                <li>
                                    {selectedOption === 'billing-date' && (
                                        <div className="flex flex-row">
                                            {[...Array(7)].map((_, colIndex) => (
                                                <div key={colIndex} className="flex flex-col ml-3">
                                                    {[...Array(5)].map((_, rowIndex) => {
                                                        const number = colIndex * 5 + rowIndex + 1;
                                                        return number <= 31 ? (
                                                            <div key={number}
                                                                 className={`flex flex-row ${rowIndex > 0 ? 'mt-1' : ''} ${colIndex > 0 ? 'ml-4' : ''}`}>
                                                                <input type="checkbox"
                                                                       checked={selectedDatesNumbers.includes(number)}
                                                                       onChange={() => handleNumberDatesToggle(number)}/>
                                                                <p className="ml-2">{number}</p>
                                                            </div>
                                                        ) : null;
                                                    })}
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </li>
                            </ul>

                            {canEditOrganizationButton && (<div className="mt-4">
                                <button
                                    type="submit"
                                    className="inline-block w-full rounded-lg bg-red-500 px-2 py-1 mt-4 mb-8 font-medium text-white sm:w-auto"
                                >
                                    Salveaza modificarile
                                </button>
                            </div>)}
                        </form>
                    </div>}

                    {clientSettingsWorkingPoint && <div className="rounded-lg bg-white w-1/2 lg:col-span-3 px-8 mt-6">
                        <form onSubmit={handleSubmitWP} className="space-y-4">
                            {/*<div className="grid grid-cols-2 justify-between">*/}
                            <div>
                                <div>
                                    <p className="text-gray-700 text-2xl mt-1">Punctul de livrare
                                        - {workingPointLocationWP}</p>
    
                                    <div>
                                        <label>Alege un punct de lucru</label>
                                        <select id="underline_select_location_wp"
                                                disabled={!canEditWorkingPointButton}
                                                className="block py-2 my-2 mx-2 px-0 w-1/2 text-sm text-gray-500 bg-transparent border-0 border-b-2 border-gray-200 appearance-none dark:text-gray-400 dark:border-gray-700 focus:outline-none focus:ring-0 focus:border-gray-200 peer"
                                                value={workingPointLocationWP}
                                                onChange={(e) => {
                                                    const newId = e.target.value;
                                                    setWorkingPointLocationWP(newId);
                                                }}
                                        >
                                            {/*<option value="">Selecteaza locatia</option>*/}
                                            {organizationLocations?.map((location: any) => (
                                                <option key={location.id}
                                                        value={location.id}>{location.id} - {location.workingPointName}</option>
                                            ))}
                                        </select>
                                    </div>
    
                                    {isCreditLimitActive &&
                                        <div className="flex flex-col py-2">
                                            <label className="mb-2">Limita de credit: <span
                                                className="text-blue-600"> {overdraftValue ? overdraftValue : "-"} </span> RON
                                            </label>
                                            <label>Soldul disponibil: <span
                                                className="text-blue-600"> {availabilityBalance ? availabilityBalance : "-"} </span> RON
                                            </label>
                                        </div>
                                    }
    
                                    {/*<label className="inline-flex items-center cursor-pointer">*/}
                                    {/*    <input type="checkbox" checked={canChooseDeliveryPoint}*/}
                                    {/*           onChange={() => setCanChooseDeliveryPoint(!canChooseDeliveryPoint)}*/}
                                    {/*           className="sr-only peer"/>*/}
                                    {/*    <div*/}
                                    {/*        className="relative w-11 h-6 bg-gray-200 rounded-full peer peer-focus:ring-4 peer-focus:ring-green-300 dark:peer-focus:ring-green-800 dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-green-600"></div>*/}
                                    {/*    <span*/}
                                    {/*        className="ms-3 text-sm font-medium text-gray-900 dark:text-gray-300">Poate alege punctul de livrare</span>*/}
                                    {/*</label>*/}

                                    {!useAtacFlow && <div className="flex flex-row">
                                        <div className="flex flex-col">
                                            <label>Magazin MBA Alocat</label>
                                            <select id="underline_select"
                                                    value={pairWorkingPointStore}
                                                    onChange={(e) => setPairWorkingPointStore(Number(e.target.value))}
                                                    className="block py-2.5 my-2 mx-2 px-0 text-sm text-gray-500 bg-transparent border-0 border-b-2 border-gray-200 appearance-none dark:text-gray-400 dark:border-gray-700 focus:outline-none focus:ring-0 focus:border-gray-200 peer">
                                                <option selected>Magazin MBA Alocat</option>
                                                {warehouses.items.map((warehouse: any) => (
                                                    <option key={warehouse.warehouseId} value={warehouse.warehouseId}>
                                                        {warehouse.name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="flex flex-col ml-3">
                                            <label>Platforma Alocata</label>
                                            <select id="underline_select"
                                                    value={pairWorkingPointWarehousePlatform ?? ""}
                                                    onChange={(e) => {
                                                        handlePairWorkingPointWarehousePlatform(e.target.value === "" ? null : e.target.value);
                                                    }}
                                                    className="block py-2.5 my-2 px-0 mx-2 text-sm text-gray-500 bg-transparent border-0 border-b-2 border-gray-200 appearance-none dark:text-gray-400 dark:border-gray-700 focus:outline-none focus:ring-0 focus:border-gray-200 peer">
                                                <option value="">Platforma Alocata</option>
                                                <option value={"STEFANESTI"}>STEFANESTI</option>
                                                <option value={"CALAN"}>CALAN</option>
                                            </select>
                                        </div>
                                    </div>}
                                    {!useAtacFlow && !pairWorkingPointWarehousePlatform && <span
                                        className="text-red-500">Selectia unei Platforme este obligatorie!</span>}
                                </div>

                                {pairWorkingPointWarehousePlatform && !useAtacFlow && <p className="text-gray-700 text-2xl mt-8">Planning Livrare</p>}

                                {pairWorkingPointWarehousePlatform && !useAtacFlow && <div className="mt-2">
                                    <table
                                        className="min-w-full divide-y-2 divide-gray-200 bg-white text-sm">
                                        <thead className="text-left">
                                        <tr>
                                            <th className="whitespace-nowrap px-4 py-2 font-medium text-gray-900"></th>
                                            <th className="whitespace-nowrap px-4 py-2 font-medium text-gray-900 text-center">Luni</th>
                                            <th className="whitespace-nowrap px-4 py-2 font-medium text-gray-900 text-center">Marti</th>
                                            <th className="whitespace-nowrap px-4 py-2 font-medium text-gray-900 text-center">Miercuri</th>
                                            <th className="whitespace-nowrap px-4 py-2 font-medium text-gray-900 text-center">Joi</th>
                                            <th className="whitespace-nowrap px-4 py-2 font-medium text-gray-900 text-center">Vineri</th>
                                            <th className="whitespace-nowrap px-4 py-2 font-medium text-gray-900 text-center">Sambata</th>
                                            <th className="whitespace-nowrap px-4 py-2 font-medium text-gray-900 text-center">Duminica</th>
                                        </tr>
                                        </thead>

                                        <tbody className="divide-y divide-gray-200">
                                        {deliveryCalendarsWP.map((row, rowIndex) => (
                                            <tr key={row.logisticActivity} className="odd:bg-gray-50">
                                                <td className="whitespace-nowrap px-4 py-2 font-medium text-gray-900">
                                                    {row.logisticActivityName}
                                                </td>
                                                {row.days.map((isChecked, dayIndex) => (
                                                    <td
                                                        key={dayIndex}
                                                        className="whitespace-nowrap px-4 py-2 text-gray-700 text-center"
                                                    >
                                                        <input
                                                            type="checkbox"
                                                            checked={isChecked}
                                                            onChange={() => handleCheckboxChangeDelivery(rowIndex, dayIndex)}
                                                        />
                                                    </td>
                                                ))}
                                            </tr>
                                        ))}
                                        </tbody>

                                    </table>
                                </div>}


                                {/*<div>*/}
                                {/*    <p className="text-gray-700 text-2xl mt-8 my-2">Atac Flow</p>*/}
                                
                                {/*    <label className="inline-flex items-center cursor-pointer mr-12">*/}
                                {/*        <input type="checkbox" checked={useAtacFlow}*/}
                                {/*               onChange={() => setUseAtacFlow(!useAtacFlow)}*/}
                                {/*               className="sr-only peer"/>*/}
                                {/*        <div*/}
                                {/*            className="relative my-1 w-11 h-6 bg-gray-200 rounded-full peer peer-focus:ring-4 peer-focus:ring-green-300 dark:peer-focus:ring-green-800 dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-green-600"></div>*/}
                                {/*        <span*/}
                                {/*            className="ms-3 ml-8 text-sm font-medium text-gray-900 dark:text-gray-300">Atac Flow</span>*/}
                                {/*    </label>*/}
                                
                                {/*    {useAtacFlow && <div className="flex flex-col w-1/2">*/}
                                {/*        <label>Magazin Alocat</label>*/}
                                {/*        <select id="underline_select"*/}
                                {/*                value={pairAtacWarehouseId!}*/}
                                {/*                onChange={(e) => setPairAtacWarehouseId(Number(e.target.value))}*/}
                                {/*                className="block py-2.5 my-2 mx-2 px-0 text-sm text-gray-500 bg-transparent border-0 border-b-2 border-gray-200 appearance-none dark:text-gray-400 dark:border-gray-700 focus:outline-none focus:ring-0 focus:border-gray-200 peer">*/}
                                {/*            <option selected>Magazin Alocat</option>*/}
                                {/*            {warehousesAtacFlow.items.map((warehouse: any) => (*/}
                                {/*                <option key={warehouse.warehouseId} value={warehouse.warehouseId}>*/}
                                {/*                    {warehouse.name}*/}
                                {/*                </option>*/}
                                {/*            ))}*/}
                                {/*        </select>*/}
                                {/*    </div>}*/}
                                
                                {/*    {useAtacFlow && <div>*/}
                                {/*        <p className="text-gray-700 text-2xl mt-4">Fidelitate</p>*/}
                                {/*        <div className="my-2 w-1/2">*/}
                                {/*            <label htmlFor="fidelity" className="relative">*/}
                                {/*                <input*/}
                                {/*                    type="text"*/}
                                {/*                    id="fidelity"*/}
                                {/*                    name="fidelity"*/}
                                {/*                    value={fidelity!}*/}
                                {/*                    onChange={handleChangeFidelity}*/}
                                {/*                    maxLength={13}*/}
                                {/*                    className="peer mt-0.5 w-full rounded border-gray-300 shadow-sm sm:text-sm border-2 py-2 pl-2"*/}
                                {/*                    inputMode="numeric"*/}
                                {/*                    pattern="\d{13}"*/}
                                {/*                />*/}
                                {/*                <span*/}
                                {/*                    className="absolute inset-y-0 start-3 -translate-y-5 bg-white px-0.5 text-sm font-medium text-gray-700 transition-transform peer-placeholder-shown:translate-y-0 peer-focus:-translate-y-5">*/}
                                {/*                Fidelitate Simply*/}
                                {/*            </span>*/}
                                {/*            </label>*/}
                                
                                {/*            {!isValidFidelity && (*/}
                                {/*                <p className="text-red-500 text-sm mt-1">Codul de fidelitate trebuie sa*/}
                                {/*                    aiba*/}
                                {/*                    exact*/}
                                {/*                    13 cifre.</p>*/}
                                {/*            )}*/}
                                {/*        </div>*/}
                                {/*    </div>}*/}
                                
                                {/*    {useAtacFlow && <div className="flex flex-row mb-4">*/}
                                {/*        <label htmlFor="number-input-due-days"*/}
                                {/*               className="block mb-2 text-gray-900 dark:text-white mr-6 mt-2">Taxa de*/}
                                {/*            livrare (RON)</label>*/}
                                {/*        <select*/}
                                {/*            id="delivery-tax"*/}
                                {/*            name="delivery-tax"*/}
                                {/*            value={transportFeeId!}*/}
                                {/*            onChange={(e) => setTransportFeeId(Number(e.target.value))}*/}
                                {/*            className="w-1/3 rounded border-gray-300 shadow-sm sm:text-sm border-2 py-2 pl-2 text-gray-700"*/}
                                {/*        >*/}
                                {/*            <option selected>Taxa nealocata</option>*/}
                                {/*            {deliveryZones.map((zone) => (*/}
                                {/*                <option key={zone.id} value={zone.id}>*/}
                                {/*                    {zone.label}*/}
                                {/*                </option>*/}
                                {/*            ))}*/}
                                {/*        </select>*/}
                                {/*    </div>}*/}
                                
                                {/*    {useAtacFlow && <div className="flex flex-row mb-4">*/}
                                {/*        <label htmlFor="number-input-due-days"*/}
                                {/*               className="block mb-2 text-gray-900 dark:text-white mr-6 mt-2">Valoarea*/}
                                {/*            minima de*/}
                                {/*            comanda (RON)</label>*/}
                                {/*        <input type="number" id="taxa-transport"*/}
                                {/*               aria-describedby="helper-text-explanation"*/}
                                {/*               className="bg-gray-50 border border-gray-300 w-1/6 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block  p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"*/}
                                {/*               value={minimumValueTransportFee!}*/}
                                {/*               onChange={(e) => {*/}
                                {/*                   const value = Number(e.target.value);*/}
                                {/*                   if (value >= 0) setMinimumValueTransportFee(value);*/}
                                {/*               }}*/}
                                {/*               placeholder="3000"*/}
                                {/*               min={0}*/}
                                {/*        />*/}
                                {/*    </div>}*/}
                                {/*</div>*/}
                            </div>
                            
                            
                            {canEditWorkingPointButton && (<div className="mt-4">
                                <button
                                    type="submit"
                                    onClick={handleSubmitWP}
                                    className="inline-block w-full rounded-lg bg-red-500 px-2 py-1 mt-4 mb-5 font-medium text-white sm:w-auto"
                                >
                                    Salveaza modificarile
                                </button>
                            </div>)}

                        </form>
                    </div>
                    }
                </div>
            </div>
        </>
    );
}

export default ClientManagementOrganization;